<template>
  <div class="client-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('side_bar.grant_token_history') }}</strong>
            </div>
            <b-col cols="12" class="text-center">

              <!-- Start of Filter session -->
             
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive combo-data table-bordered">
                <table class="table table-striped table-hover table-sm header-pointer">
                  <thead>
                  <tr>
                    <th scope="col">{{$t('game.start_at')}}</th>
                    <th scope="col">{{$t('game.rule_name')}}</th>
                    <th scope="col">{{$t('game.total_customer')}}</th>
                    <th scope="col">{{$t('game.number_customers_granted_success')}}</th>
                    <th scope="col">{{$t('game.number_customers_granted_fail')}}</th>
                    <th scope="col">{{$t('game.status')}}</th>
                    <th scope="col">{{$t('common.failed_customers')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" colspan="7">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row" class="text-left"><span>{{ convertDateTimeFormat(item.start_at) }}</span></td>
                    <td scope="row" class="text-left"><span>{{ item.game_data.rule_name }}</span></td>
                    <td scope="row" class="text-left"><span>{{ item.total_customer }}</span></td>
                    <td scope="row" class="text-left"><span>{{ item.total_emit_braze_event_success }}</span></td>
                    <td scope="row" class="text-left"><span>{{ item.failed_customers_count }}</span></td>
                    <td scope="row" class="text-left">
                      <span v-if="item.status === 'STARTED'" class="badge badge-info">{{ item.status }}</span>
                      <span v-else-if="item.status === 'PROCESSING'" class="badge badge-primary">{{ item.status }}</span>
                      <span v-else-if="item.status === 'COMPLETED'" class="badge badge-success">{{ item.status }}</span>
                      <span v-else-if="item.status === 'PARTIAL FAILED'" class="badge badge-warning">{{ item.status }}</span>
                      <span v-else-if="item.status === 'FAILED'" class="badge badge-danger">{{ item.status }}</span>
                      <span v-else class="badge badge-light">{{ item.status }}</span>
                    </td>
                    <td scope="row" width="200">
                      <b-button v-if="item.failed_customers_log_path" size="sm" variant="primary" v-on:click="getSignedUrl(item.failed_customers_log_path)">
                        <i class="fa fa-download"></i> {{$t('common.download')}}
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  const CancelToken = axios.CancelToken
  let cancel = null
  let vm = null

  export default {
    name: 'HistoryList',
    components: {
    },
    data: function () {
      return {
        type: 'like',
        statuses: [],
        status_options: [],
        filter: {
          options: [],
          selected: null,
          status: '',
          field: null,
          key: null,
        },
        dataTable: {
          items: [],
          fields: [],
          sort: {},
          currentPage: 1,
          total: 0,
          perPage: 10,
          source: null
        },
        item: {}
      }
    },
    methods: {
      /**
       * refresh data for data table
       */
      refreshData () {
        if (cancel != null) {
          cancel()
        }
        vm.axios.coupon.getGrantTokenHistory(function(response){
          vm.dataTable.items = response.data.data
        })
      },
      getSignedUrl: function(s3_key){
        vm.axios.coupon.getSignedUrl(s3_key, function(response){
          if(response.data.data.downloadUrl){
            window.open(response.data.data.downloadUrl, '_blank') 
          }
        })
      },
      convertDateTimeFormat (val) {
        val = this.convertUTCToClientTime(val)
        return this.$moment(val, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD-MM-YYYY')
      }
    },
    created: function () {
      vm = this
      vm.$Progress.start()
      vm.refreshData()
    },
    beforeDestroy: function () {
    },
    watch: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/game/HistoryList.vue